import message from '../messages/Message';
import { Loading } from '@op/opds.opux';
import '../App.css';
import TabsView from './TabsView';
import { usePriceListContent } from '../context/PriceListContext';


const LandingPage = () => {

  const { response } = usePriceListContent();
  
  if (!response) {
    return <div><Loading /></div>;
  }

  return (
    <div className="opds App">
      <header className="App-header">
        <div className="runko">
          <h2 className="header">{message('bank_name')}</h2>
          <TabsView />
        </div>
      </header>
    </div>
  );
};

export default LandingPage;